import { JobPostingTitleComponent } from '@/components/JobPosting/JobPostingTitle'
import CardLabels from '@/components/JobPosting/Labels'
import { Block } from '@/components/base/Block'
import FavoriteIcon from '@/components/base/Icon/FavoriteIcon'
import { Text5 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { size } from '@/styles/device'
import spaceStyle from '@/styles/space'
import {
  type Labelsv1Label,
  type V1JobPostingCardAttachmentInfo
} from 'mnvm-mypage-app-ts-if'
import styled from 'styled-components'
import { JobInformation } from './JobPostingCardType1'
import RecommendLabel from './RecommendLabel'
import AdvisorCommentLabel from './AdvisorCommentLabel'
import borderRadius from '@/styles/border_radius'
import { isEmpty } from 'lodash'
import useIsMobile from '@/hooks/useMobile'
import ConsideringLabel from './ConsideringLabel'

const JobPostingCardType3Block = styled(Block)`
  width: 350px;
  box-sizing: border-box;
  position: relative;
  @media only screen and (max-width: ${size.mobile}) {
    width: 160px;
  }
`

const StyledImageContainer = styled.div`
  width: 100%;
  height: 150px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-top-right-radius: ${borderRadius.M} ${borderRadius.M};
    border-top-left-radius: ${borderRadius.M} ${borderRadius.M};
  }
  @media only screen and (max-width: ${size.mobile}) {
    width: 158px;
  }
`

export interface JobPostingCardType3Props {
  labels: Labelsv1Label[]
  attachmentInfo?: V1JobPostingCardAttachmentInfo[]
  title: string
  code: string
  smallTitle: string
  id: string
  imageUrl?: string
  onClickShowDetailButton: () => void
  isLiked?: boolean
  isRecommended?: boolean
  isAcceptedOffer?: boolean
  isDeclinedApplication?: boolean
  advisorComment?: string
  isConsidering?: boolean
}

const JobPostingCardType3 = (props: JobPostingCardType3Props): JSX.Element => {
  const { theme } = useApp()
  const isMobile = useIsMobile()

  const recommendLabelHeight = 36
  const isShowAdvisorComment = !isEmpty(props.advisorComment)
  const isRecommended = props.isRecommended ?? false
  const isConsidering = props.isConsidering ?? false
  const cardNoImageHeight =
    234 +
    (isRecommended ? recommendLabelHeight : 0) +
    (isShowAdvisorComment ? recommendLabelHeight : 0) +
    (isConsidering ? recommendLabelHeight : 0)

  return (
    <JobPostingCardType3Block
      border
      borderRadius={{ all: spaceStyle.XS }}
      height={props.imageUrl != null ? '384px' : `${cardNoImageHeight}px`}
    >
      <ConsideringLabel
        isShow={isConsidering}
        isAbsolute={props.imageUrl != null}
        isTransparent={props.imageUrl != null}
      />
      <RecommendLabel
        isShow={isRecommended}
        isAbsolute={props.imageUrl != null}
        rounded={isConsidering ? borderRadius.NONE : borderRadius.M}
        isTransparent={props.imageUrl != null}
        top={isConsidering ? (isMobile ? '33px' : '37px') : 0}
      />
      <AdvisorCommentLabel
        isShow={isShowAdvisorComment}
        isAbsolute={props.imageUrl != null}
        rounded={
          isRecommended || isConsidering ? borderRadius.NONE : borderRadius.M
        }
        isTransparent={props.imageUrl != null}
        top={
          isRecommended && isConsidering
            ? isMobile
              ? '66px'
              : '75px'
            : isRecommended || isConsidering
              ? isMobile
                ? '33px'
                : '37px'
              : 0
        }
      />
      {props.imageUrl != null && (
        <StyledImageContainer
          style={{
            overflow: 'hidden'
          }}
        >
          <img
            src={props.imageUrl}
            alt="job posting image"
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        </StyledImageContainer>
      )}
      <Block
        onClick={props.onClickShowDetailButton}
        cursor="pointer"
        textAlign="left"
        height="100%"
        padding={{
          horizontal: spaceStyle.S,
          top: spaceStyle.S,
          bottom: spaceStyle.S
        }}
      >
        <CardLabels items={props.labels} />
        <JobPostingTitleComponent
          isCard
          title={props.title}
          smallTitle={props.smallTitle}
          maxLines={2}
        />
        {props.attachmentInfo?.map((e) => {
          return (
            <JobInformation
              key={e.text}
              iconType={e.iconType}
              text={e.text ?? ''}
              maxLines={1}
            />
          )
        })}
        <Text5
          textColor={theme.subTextColor}
          margin={{ horizontal: spaceStyle.NONE }}
        >
          {`求人番号：${props.code}`}
        </Text5>
      </Block>
      <Block style={{ position: 'absolute', bottom: 4, right: 8, height: 28 }}>
        <FavoriteIcon id={props.id} isLiked={props.isLiked} />
      </Block>
    </JobPostingCardType3Block>
  )
}

export default JobPostingCardType3
